// Minimal stroke icons for the nav rail. Each is a 18x18 currentColor
// stroke glyph so it inherits text colour (muted → ink → accent when
// active). Kept inline + tiny rather than pulling an icon library.

import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function Base({ children, ...props }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function IconToday(p: IconProps) {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </Base>
  );
}

export function IconFood(p: IconProps) {
  return (
    <Base {...p}>
      <path d="M4 3v7a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V3" />
      <path d="M6 12v9" />
      <path d="M18 3c-1.5 0-3 2-3 5s1.5 4 3 4v9" />
    </Base>
  );
}

export function IconWeight(p: IconProps) {
  return (
    <Base {...p}>
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <circle cx="12" cy="13" r="4" />
      <path d="M12 13l1.5-3" />
    </Base>
  );
}

export function IconActivity(p: IconProps) {
  return (
    <Base {...p}>
      <path d="M3 12h4l2 6 4-14 2 8h6" />
    </Base>
  );
}

export function IconDiet(p: IconProps) {
  return (
    <Base {...p}>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <path d="M9 4.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V6H9z" />
      <path d="M8.5 11l1.4 1.4 2.6-3" />
      <path d="M8.5 16h7" />
    </Base>
  );
}

export function IconHeart(p: IconProps) {
  return (
    <Base {...p}>
      <path d="M12 20.5C7 16.5 3 13.4 3 9.2 3 6.6 5 4.6 7.5 4.6c1.6 0 3.2.9 4.5 2.6 1.3-1.7 2.9-2.6 4.5-2.6C19 4.6 21 6.6 21 9.2c0 4.2-4 7.3-9 11.3z" />
      <path d="M7 11.3h2.4l1-2 1.6 3.6 1-1.6H17" />
    </Base>
  );
}

export function IconSleep(p: IconProps) {
  return (
    <Base {...p}>
      <path d="M20 14a8 8 0 0 1-10.5-10.5A8.5 8.5 0 1 0 20 14z" />
    </Base>
  );
}

export function IconTrends(p: IconProps) {
  return (
    <Base {...p}>
      <path d="M3 3v18h18" />
      <path d="M7 14l3-4 3 2 4-6" />
    </Base>
  );
}

export function IconCoach(p: IconProps) {
  return (
    <Base {...p}>
      <path d="M21 12a8 8 0 0 1-11.6 7.1L4 21l1.9-5.4A8 8 0 1 1 21 12z" />
    </Base>
  );
}

export function IconGoals(p: IconProps) {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1" />
    </Base>
  );
}

export function IconConnections(p: IconProps) {
  return (
    <Base {...p}>
      <path d="M9 12a3 3 0 0 1 0-4l2-2a3 3 0 0 1 4 4l-1 1" />
      <path d="M15 12a3 3 0 0 1 0 4l-2 2a3 3 0 0 1-4-4l1-1" />
    </Base>
  );
}

export function IconHelp(p: IconProps) {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.2 9.5a2.8 2.8 0 0 1 5.4 1c0 1.8-2.6 2.5-2.6 2.5" />
      <line x1="12" y1="17" x2="12" y2="17" />
    </Base>
  );
}

export function IconSettings(p: IconProps) {
  return (
    <Base {...p}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 0 1-4 0v-.1A1.6 1.6 0 0 0 6.8 19.3a2 2 0 1 1-2.8-2.8l.1-.1A1.6 1.6 0 0 0 4.6 13.6 2 2 0 0 1 3 12a2 2 0 0 1 1.6-1.9 1.6 1.6 0 0 0 .7-2.7l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 2.7-1.1V3a2 2 0 0 1 4 0v.1a1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7H21a2 2 0 0 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1z" />
    </Base>
  );
}
